import { lazy } from "react";
import { RouteObject } from "react-router-dom";

import OnboardPractice from "@/admin/OnboardPractice";
import { ProjectPage } from "@/admin/ProjectPage";

import Protected from "./Protected";

const ProjectDetailsPage = lazy(() =>
  import("@/admin/ProjectDetailsPage").then((module) => ({ default: module.ProjectDetailsPage })),
);
const ProjectQuestionnairePage = lazy(() =>
  import("@/admin/ProjectQuestionnairePage").then((module) => ({
    default: module.ProjectQuestionnairePage,
  })),
);
const ProjectSetupPage = lazy(() =>
  import("@/admin/ProjectSetupPage").then((module) => ({ default: module.ProjectSetupPage })),
);
const ProjectInviteProvider = lazy(() =>
  import("@/admin/ProjectInviteProvider").then((module) => ({
    default: module.ProjectInviteProvider,
  })),
);

const LabAccountManagementPage = lazy(() =>
  import("@/admin/LabAccountManagementPage").then((module) => ({
    default: module.LabAccountManagementPage,
  })),
);
const ProjectFeatureFlagsPage = lazy(() =>
  import("@/admin/ProjectFeatureFlagsPage").then((module) => ({
    default: module.ProjectFeatureFlagsPage,
  })),
);
const PractitionerRolesPage = lazy(() =>
  import("@/admin/PractitionerRolesPage").then((module) => ({
    default: module.PractitionerRolesPage,
  })),
);
const ProductionAccessReportPage = lazy(() =>
  import("@/admin/ProductionAccessReportPage").then((module) => ({
    default: module.ProductionAccessReportPage,
  })),
);

const isDevelopment = import.meta.env.VITE_ENV === "DEVELOPMENT";
const isLocalMedplum = import.meta.env.VITE_MEDPLUM_URL?.startsWith("http://localhost");

const projectChildren: RouteObject[] = [
  {
    path: "details",
    element: <ProjectDetailsPage />,
  },
  {
    path: "setup",
    element: <ProjectSetupPage />,
  },
  {
    path: "invite-provider",
    element: <ProjectInviteProvider />,
  },
  {
    path: "lab-accounts",
    element: <LabAccountManagementPage />,
  },
  {
    path: "onboard-practice",
    element: <OnboardPractice />,
  },
  {
    path: "feature-flags",
    element: <ProjectFeatureFlagsPage />,
  },
  {
    path: "access-reports",
    element: <ProductionAccessReportPage />,
  },
  {
    path: "practitioner-roles",
    element: <PractitionerRolesPage />,
  },
];

// Only add questionnaire route in development and localhost environments
if (isDevelopment && isLocalMedplum) {
  projectChildren.push({
    path: "questionnaire",
    element: <ProjectQuestionnairePage />,
  });
}

export const AdminRoutes: RouteObject[] = [
  {
    path: "/admin/project",
    element: (
      <Protected routes={["/admin"]} allowedRoles={["Admin"]}>
        <ProjectPage />
      </Protected>
    ),
    children: projectChildren,
  },
];
